import { TicketStatus } from 'utils/enums';

export const TICKET_STATUS_OPTION = {
  [TicketStatus.CHOTIEPNHAN]: {
    color: '#FF9500'
  },
  [TicketStatus.DANGXULY]: {
    color: '#34C759'
  },
  [TicketStatus.CHUYENTRUNGTAM]: {
    color: '#1564E8'
  },
  [TicketStatus.HOANTAT]: { color: '#1564E8' },
  [TicketStatus.HUY]: { color: '#1564E8' },
  [TicketStatus.TRUONGCACHUYENPHONG]: { color: '#1564E8' },
  [TicketStatus.TRUONGCACHUYENPHONGKYTHUAT]: { color: '#1564E8' }
};
